export var transformInterval = function transformInterval(interval) {
  var capitalLetter = "".concat(interval.charAt(0).toUpperCase()).concat(interval.slice(1));
  return capitalLetter.split('_').join(' ');
};